var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.419,
    height: 13.456,
    viewBox: "0 0 22.419 13.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-handshake",
    "data-name": "Icon awesome-handshake",
    d: "M15.227,4.5H12.218a1.12,1.12,0,0,0-.757.294L8.018,7.947s-.007.011-.011.014a1.393,1.393,0,0,0-.074,1.962,1.461,1.461,0,0,0,1.965.095s.011,0,.014-.007l2.8-2.564a.56.56,0,0,1,.757.827l-.914.837,5.1,4.14a2.524,2.524,0,0,1,.277.27V6.742L16.019,4.829A1.113,1.113,0,0,0,15.227,4.5Zm3.829,2.249v7.843a1.12,1.12,0,0,0,1.121,1.121h2.242V6.749Zm1.681,7.843a.56.56,0,1,1,.56-.56A.562.562,0,0,1,20.737,14.592ZM0,15.709H2.242a1.12,1.12,0,0,0,1.121-1.121V6.749H0Zm1.681-2.238a.56.56,0,1,1-.56.56A.562.562,0,0,1,1.681,13.471Zm15.269.652-5.23-4.246-1.051.963A2.521,2.521,0,0,1,7.262,7.124L10.127,4.5H7.192a1.119,1.119,0,0,0-.792.329L4.484,6.742v7.843h.641l3.17,2.869a2.241,2.241,0,0,0,3.153-.326l.007-.007.627.543a1.3,1.3,0,0,0,1.832-.189l1.1-1.352.189.154a1.119,1.119,0,0,0,1.576-.165l.333-.41a1.123,1.123,0,0,0-.161-1.58Z",
    transform: "translate(0 -4.5)",
    fill: "#4477c0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconHandshake);
export default __webpack_public_path__ + "static/media/nav-icon-handshake.cb7258ac59cd5d8eb0b538ac0f605cd5.svg";
export { ForwardRef as ReactComponent };